const controlPanelStyles = {
  container: {
    fontSize: '30px'
  },
  sticky: {
    position: 'sticky',
    top: '0',
    borderRadius: '4px 4px 0 0',
    padding: '.2em'
  },
  holder: {
    display: 'flex',
    alignItems: 'center'
  }
}

const controlButtonStyles = ({ COLORS }, b) => ({
  button: {
    width: '1em',
    height: '1em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: COLORS.TEXT.DARK_GREY.NORMAL,
    borderRadius: '.1em',
    '&:hover': {
      background: 'rgba(0, 0, 0, 0.05)'
    },
    '&:active': {
      background: 'rgba(0, 0, 0, 0.1)'
    }
  },
  active: {
    color: COLORS.BLUE.NORMAL
  },
  content: {
    fontSize: '.5em',
    '& svg': {
      display: 'block'
    }
  }
})

const separatorStyles = {
  separator: {
    width: '1px',
    backgroundColor: '#ccc',
    height: '.5em',
    margin: '0 .2em'
  }
}

export { controlButtonStyles, controlPanelStyles, separatorStyles }
